<template>
  <div class="product-title" :class="{ 'product-title--archive': isArchiveProduct }">
    <h1 class="product-title__title" v-if="titleArray.length > 1">
      {{ titleArray[0] }}<br />
      <span>({{ titleArray[1] }}</span>
    </h1>

    <h1 v-else class="product-title__title">
      {{ product.title }}
    </h1>
    <ProductPrices class="product-title__prices" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useProductInject } from '../../context/useProductContext'
import ProductPrices from './ProductPrices.vue'

const { product } = useProductInject()

const titleArray = product.title.split('(')
const isArchiveProduct = computed(() => product.tags?.includes('collection-archive'))
</script>

<style lang="scss">
@import '~styles/base';

.product-title {
  @include breakpoint('l') {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--gutter);
  }

  &--archive {
    @include breakpoint('l') {
      grid-template-columns: 1fr;
    }
  }

  &__title {
    @include sans;
    text-transform: uppercase;
    font-size: 25px;
    line-height: 27px;
  }

  &__prices {
    @include breakpoint('l') {
      text-align: right;
      align-self: flex-end;
    }

    @include breakpoint('l+') {
      display: none !important;
    }
  }
}
</style>
